import React from 'react';
import { Users, CheckCircle, XCircle, ShieldCheck } from 'lucide-react';

const ClientStats = ({ 
  totalClients = 0,
  activeClients = 0,
  inactiveClients = 0,
  verifiedClients = 0,
  className = ''
}) => {
  const stats = [
    {
      key: 'total',
      title: 'Total Clients',
      value: totalClients,
      icon: Users,
      bgColor: 'bg-gray-50',
      borderColor: 'border-gray-200',
      iconBg: 'bg-gray-100',
      iconColor: 'text-gray-600'
    },
    {
      key: 'active',
      title: 'Active',
      value: activeClients,
      icon: CheckCircle,
      bgColor: 'bg-green-50',
      borderColor: 'border-green-200',
      iconBg: 'bg-green-100',
      iconColor: 'text-green-600'
    },
    {
      key: 'inactive',
      title: 'Inactive',
      value: inactiveClients,
      icon: XCircle,
      bgColor: 'bg-red-50',
      borderColor: 'border-red-200',
      iconBg: 'bg-red-100',
      iconColor: 'text-red-600'
    },
    {
      key: 'verified',
      title: 'Verified',
      value: verifiedClients,
      icon: ShieldCheck,
      bgColor: 'bg-blue-50',
      borderColor: 'border-blue-200',
      iconBg: 'bg-blue-100',
      iconColor: 'text-blue-600'
    }
  ];

  return (
    <div className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 ${className}`}>
      {stats.map((stat) => {
        const Icon = stat.icon;
        return (
          <div
            key={stat.key}
            className={`${stat.bgColor} ${stat.borderColor} rounded-lg border p-5 flex items-center gap-4 hover:shadow-md transition-shadow duration-200`}
          >
            <div className={`${stat.iconBg} ${stat.iconColor} p-3 rounded-full flex-shrink-0`}>
              <Icon className="h-6 w-6" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-gray-600 mb-1">
                {stat.title}
              </p>
              <p className="text-3xl font-bold text-gray-900">
                {stat.value.toLocaleString()}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ClientStats;
